import { render, staticRenderFns } from "./EstimateDetail.vue?vue&type=template&id=71a082a6&scoped=true"
import script from "./EstimateDetail.vue?vue&type=script&lang=js"
export * from "./EstimateDetail.vue?vue&type=script&lang=js"
import style0 from "./EstimateDetail.vue?vue&type=style&index=0&id=71a082a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a082a6",
  null
  
)

export default component.exports